<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">Customer Journey Flow</div>
        <div class="section-subTitle my-2">View Customer Journey Flow.</div>
      </div>
    </div>

    <!-- <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{selectedvalue}}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
            >{{list.name}}</b-dropdown-item>
          </b-dropdown>
        </div>

        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active':''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active':''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>-->

    <!-- LIST VIEW DESIGNATION -->
    <div class="desg-list-container">
      <div class="desg-list-header">
        <div>Customer</div>

        <!-- <div class="pr-5">{{ $tc('status', 2) }}</div> -->
      </div>
      <ul class="desg-list">
        <li v-for="(customer, customerLoopKey) in customerList" :key="customerLoopKey">
          <div>{{customer.first_name}}&nbsp;{{customer.last_name}}</div>

          <div class="d-flex align-items-center">
            <button class="btn-blue" @click="goToFlow(customer.cust_id)">View Flow</button>
            <!-- <label class="ios-switch">
              <input
                v-model="segment.segment_is_active"
                value="Y"
                disabled
                type="checkbox"
                class="ios-checkbox"
              />
              <span class="switch-slider"></span>
            </label>
            <b-dropdown right variant="edit" class="ml-4">
              <b-dropdown-item
                :to="{ name: 'Edit Segment',params:{segment_id:segment.segment_id} }"
              >
                <span class="edit-pen mr-1"></span>
                {{ $t('edit') }}
              </b-dropdown-item>
              <b-dropdown-item
                :to="{ name: 'View Segment',params:{segment_id:segment.segment_id} }"
              >
                <span class="icon-eye mr-1"></span>
                {{ $t('view') }}
              </b-dropdown-item>
            </b-dropdown>-->
          </div>
        </li>
      </ul>
      <!-- <table>
        <tbody>
          <tr>
            <td colspan="2">
              <div class="h6 my-3 text-center">{{ $t('NoRecords') }}</div>
            </td>
          </tr>
        </tbody>
      </table>-->
    </div>
    <br />
    <!-- <b-pagination
      v-model="currentPage"
      total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>-->
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      customerList: []
    };
  },
  mounted() {
    this.getCustomers();
  },
  methods: {
    getCustomers: function() {
      let payload = {
        tableName: "customers",
        cust_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.customerList = data.Records;
            console.log("this.customerList :>> ", this.customerList);
          } else {
            // console.log("show error1 :", data.message);
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    goToFlow(cust_id) {
      this.$router.push({
        name: "View User Journey Flow",
        params: { cust_id: cust_id }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MarketingAutomationContainer/UserJourneyComponents/customerList.vue